import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=7281d40f&scoped=true&"
import script from "./radio-group.vue?vue&type=script&lang=js&"
export * from "./radio-group.vue?vue&type=script&lang=js&"
import style0 from "./radio-group.vue?vue&type=style&index=0&id=7281d40f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7281d40f",
  null
  
)

export default component.exports